export default __webpack_public_path__ + "static/media/shareEn2.3525cf85.jpg";